import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { CONOFFICER_API } from '../ApiNames';
import { LoginService } from '../services/LoginService';
import { Panel } from 'primereact/panel';
import { useNavigate } from 'react-router-dom';
import { Divider } from 'primereact/divider';
import './CLoginoff.css';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';

interface LoginData {
  username: string;
  password: string;
  email: string;
  usertype: string;
  checked: any;
}

export const CLoginoff = () => {
  const uid = window.sessionStorage.getItem('uid');
  const [globalFilter, setGlobalFilter] = useState('')
  const dispatch = useDispatch()
  const [addDilog, setaddDilog] = useState(false);
  const [email, setEmail] = useState(''); 
   const [uemail, setUemail] = useState('');

  const [userpass, setPassword] = useState('');
  const navigate = useNavigate();
  const toast = useRef<Toast | null>(null);
  const [searchdata, setSearchData] = useState<[]>([]);
  console.log(searchdata,"login details");
  const [userData, setUserData] = useState<LoginData[]>([]);
  //const [newEditData, setNewEditData] = usestate<
  const Editdata = (user: any) => { 
    setEditData ({
       
      uemail: user.uemail,
      userpass: user.userpass,


    });
    console.log(uemail);

    setaddDilog(true);
    
}
const [editData, setEditData] = useState({
  uemail: '',
  userpass: '',
 

});

  const Searchdata = async () => {
    try {
      const payload = { q: 1, email:email };
      const apiname = CONOFFICER_API.login_API;
      const data = await LoginService.getData(apiname, payload);
      setGlobalFilter(email);
      setSearchData(data);
    } catch (error) {
    }
  }
  const handleLogin = async (values: any) => {

    try {
      //const payload = { username: values.email, password: values.password };
      const payload = { q: 2, email:editData.uemail, password: editData.userpass}
      const apiname = CONOFFICER_API.login_API;
      const data = await LoginService.getData(apiname, payload);
      
      if (data && data.length > 0) {
        const { userid, usertype, photo, pname } = data[0];

        // Store user information in session storage
        window.sessionStorage.setItem("uid", userid);
        window.sessionStorage.setItem("usertype", usertype);
        window.sessionStorage.setItem("photo", photo);
        window.sessionStorage.setItem("username", pname);

        // Navigate based on auth_code and usertype
        if (window.sessionStorage.getItem('auth_code') === 'YES') {
          navigate('/');
        } else if (usertype === 'patient') {
          navigate('/patientdashboard');
        }
      } else {
        console.error("Invalid login response: No user data found.");
        // Optionally handle no data scenario
      }
    } catch (error) {
      // Optionally display error message to user
    }
  };

  const close = async () => {
    setaddDilog(false);

  }
//for help
 const [openHelp, setHelp] = useState(false);
 const url1 = window.sessionStorage.getItem("apiRoot");
 const IUrl = `${url1}/help/consultancysearchpaientlogin.php`;
 const helpImg = `${url1}/help/help3.png`;
 const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
   event.preventDefault();
   const newWindowReference = window.open(
     targetUrl,
     'newwindow',
     'width=1000,height=1000,noopener,noreferrer'
   );
 
   if (newWindowReference) {
       newWindowReference.opener = null;
   }
 };
  return (

    <div style={{ marginLeft: '250px', marginTop: '60px' }}>
      <div className="content-wrapper" >
        <section className="content" >
          <div className="grid">
            <div className="col-9">
              <h2>Search Patient</h2>
            </div>
            <div className="col-16" style={{ textAlign:"right"}}>
                    <a
                      title="help"
                      onClick={(e) => openWindow(e, IUrl)}
                      style={{

                        color: "blue",
                        fontSize: 15, cursor: "pointer"
                      }}
                    >Help for this Page &nbsp;
                      <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                    </a>
                  </div>
          </div>
          <div className="container">
            <Panel header="Search Patient">
              <br></br>
              <br></br>
              <div className="form-group">
                <div className='grid'>
                  <div className='col-1'></div>

                  <div className='col-4'>
                    <label htmlFor="email" className="label">E-Mail</label>
                  </div>
                </div>
                <div className='grid'>
                  <div className='col-2'></div>
                  <div className='col-6'>
                    <InputText id="email" type="email" style={{ width: '35vw' }} name="email" onChange={(e) => setEmail(e.target.value)} value={email} placeholder='Enter Email....' />
                  </div>
                </div>


              </div>
              <br></br>
              <br></br>
              <br></br>
              <div className="button-container">
                <Button label="Search Patient" className="p-button-primary" onClick={Searchdata}  />
                
              </div>
            </Panel>
          </div>
          <br></br>
        </section>
        <section>
          
          <Panel>
            <div className='grid'>
              {searchdata.map((user: any, index) => (
                <div className='col-4' key={index}>
                  <div className="widget-user-header bg-info" style={{ height: '100px', backgroundColor: 'rgb(255, 193, 7)', display: 'flex', alignItems: 'center', width: '100%' }}>
                    <img
                      src={user.photo}
                      alt="User Avatar"
                      style={{
                        width: '100px',
                        height: '60px',
                        borderRadius: '50%',
                        marginRight: '15px'
                      }}
                    />
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <h1 className="widget-user-username" style={{ color: '##000', fontWeight: '200', fontSize: '25px', marginBottom: '10px' }}>
                        {user.name}
                      </h1>
                      <Divider />
                      <Divider />
                      </div > 
                     
                    <div>
                    <h4 style={{ textAlign: "right" }}>Patient</h4>
                    </div>
                  </div>

                  <div className='grid' style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                    <strong style={{ width: '100px' }}>E-mail</strong>
                    <p className="text-muted" style={{ backgroundColor: 'rgb(0, 123, 255)', color: 'white', borderRadius: '6px', textAlign: 'center', marginLeft: '30px', padding: '5px 10px' }}>
                      {user.email}
                    </p>
                  </div>
                  <hr style={{ width: '100%', border: '0.5px solid rgba(0, 0, 0, 0.1)', marginTop: '5px', marginBottom: '5px' }} />
                  <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                    <strong style={{ width: '100px' }}>Phone No.</strong>
                    <p className="text-muted" style={{ backgroundColor: 'rgb(23, 162, 184)', color: 'white', borderRadius: '6px', textAlign: 'center', marginLeft: '30px', padding: '5px 10px' }}>
                      {user.phone}
                    </p>
                  </div>
                  <hr style={{ width: '100%', border: '0.5px solid rgba(0, 0, 0, 0.1)', marginTop: '5px', marginBottom: '5px' }} />
                  <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                    <strong style={{ width: '100px' }}>Address</strong>
                    <p className="text-muted" style={{ backgroundColor: 'rgb(40, 167, 69)', color: 'white', borderRadius: '6px', textAlign: 'center', marginLeft: '30px', padding: '5px 10px' }}>
                      {user.address}
                    </p>
                  </div>
                  <hr style={{ width: '100%', border: '0.5px solid rgba(0, 0, 0, 0.1)', marginTop: '5px', marginBottom: '5px' }} />
                  <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '20px' }}>
                    <Button label="Login" className="p-button-info" onClick={() => Editdata(user)} />
                  </div>
                </div>
              ))}
            </div>

          </Panel>
        </section>
      </div>

      <Dialog header="Login Details" visible={addDilog} style={{ width: '35vw', height: '40vh' }} onHide={close}>
        <div className="grid pt-1">
          <div className="col-3">
            <label htmlFor="email" className="col-sm-2 control-label">E-Mail:</label>
          </div>
          <div className="col-6">  
       <InputText id="email" type="email" style={{ width: '20vw' }} name="email" onChange={(e) => setEditData({ ...editData, uemail: e.target.value })} value={editData.uemail} disabled/>

          </div>
        </div>

        <div className="grid pt-3">
          <div className="col-3">
            <label htmlFor="password" className="col-sm-2 control-label">Password:</label>
          </div>
          <div className="col-6">
       <InputText id="password" type="password" style={{ width: '20vw' }} name="password" onChange={(e) => setEditData({ ...editData, userpass: e.target.value })} value={editData.userpass} disabled/>

          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
          <Button label="Close" onClick={close} severity="secondary" />
          <Button label="Login" onClick={handleLogin} style={{ float: 'right' }} />
        </div>
      </Dialog>

    </div >

  )
};
